export default __webpack_public_path__ + "static/media/fence.fba7de56.png";